import { createSvgIcon } from '@mui/material/utils'

export default createSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M12 3.4a8.6 8.6 0 1 0 0 17.2 8.6 8.6 0 0 0 0-17.2ZM1.4 12C1.4 6.146 6.146 1.4 12 1.4c5.854 0 10.6 4.746 10.6 10.6 0 5.855-4.746 10.6-10.6 10.6-5.854 0-10.6-4.745-10.6-10.6Zm6.499-4.1a1 1 0 0 1 1.414 0L12 10.585 14.687 7.9a1 1 0 1 1 1.414 1.414L13.414 12l2.687 2.687a1 1 0 1 1-1.414 1.415L12 13.415l-2.687 2.687a1 1 0 0 1-1.414-1.415L10.586 12 7.899 9.313a1 1 0 0 1 0-1.414Z"
  />,
  'XCircleContained'
)
